import { Apps } from '~/shared';
import { createSlice } from '../wrappers';

interface ITabletSlice {
	activeApp: Apps;
}

const initialState: ITabletSlice = {
	activeApp: Apps.Launcher,
};

const tabletSlice = createSlice({
	name: 'tablet',
	initialState,
	reducers: {
		setActiveApp: (state, action) => {
			state.activeApp = action.payload;
		},
		returnToLauncher: (state) => {
			state.activeApp = Apps.Launcher;
		},
	},
});

export const { setActiveApp, returnToLauncher } = tabletSlice.actions;

export default tabletSlice.reducer;
